module.exports = __webpack_public_path__ + "img/arrow-right-blue.0b97295f.svg";